<script>
import axios from "axios";
import Loader from '../../views_mobagile/components/loader.vue'

import {
  authMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      exibeSegLogin: false,
      updating: false,
      email: "",
      codverify: "3232",
      password: "",
      submitted_1: false,
      submitted_2: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  components: { Loader },
  validations: {
    email: {
      required: helpers.withMessage("Campo e-mail obrigatório, favor preencher", required),
      email: helpers.withMessage("Favor inserir um endereço de e-mail válido", email),
    },
    password: {
      required: helpers.withMessage("Campo password obrigatório, favor preencher", required),
    },
    codverify: {
      required: helpers.withMessage("Campo código de verificação obrigatório, favor preencher", required),
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...notificationMethods,


    criarConta(){
      console.log('criarConta')
      this.$router.replace('/register')


    },

    primeiroLogin(){
      console.log('primeiroLogin')
      this.v$.$touch();
      this.submitted_1 = true
      this.updating = true

      if (this.email !== '' && this.password !== ''){
        setTimeout(function(scope) {
          scope.updating = false
          scope.exibeSegLogin = true
        }, 500, this)
      }

    },

    segundoLogin() {
      console.log('segundoLogin_2')
      console.log(this.v$.$invalid)
      this.submitted_2 = true

      if (this.email !== '' && this.password !== ''){

        if (this.v$.$invalid) {
          return;
        } else {
          this.updating = true
          if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
            console.log('login_Firebase_0')

            this.tryingToLogIn = true;
            // Reset the authError if it existed.
            this.authError = null;
            return (
                this.logIn({
                  email: this.email,
                  password: this.password,
                })
                    // eslint-disable-next-line no-unused-vars
                    .then((token) => {
                      this.tryingToLogIn = false;
                      this.isAuthError = false;
                      if (token && token['stsTokenManager'] && token['stsTokenManager']['accessToken']) {
                        localStorage.setItem('token', token['stsTokenManager']['accessToken']);
                      } else {
                        console.error('Token or stsTokenManager or accessToken is undefined');
                      }
                      console.log('Token received from Firebase:')
                      console.log(token)

                      // Log the token structure to help diagnose issues
                      console.log('Token structure:', {
                        hasToken: !!token,
                        hasStsTokenManager: token && !!token['stsTokenManager'],
                        hasAccessToken: token && token['stsTokenManager'] && !!token['stsTokenManager']['accessToken']
                      })

                      // alterar dados de teste
                      // Safely get the token if available
                      const accessToken = token && token['stsTokenManager'] && token['stsTokenManager']['accessToken'] 
                        ? token['stsTokenManager']['accessToken'] 
                        : '';

                      localStorage.setItem('user', JSON.stringify({
                        "id": '123456',
                        "email": 'rogerio@mobagile.com.br',
                        "nome": 'rogerio',
                        "tipo": 'user',
                        "menus": null,
                        "token": accessToken
                      }))

                      localStorage.setItem('emprconf', JSON.stringify({
                        'cnpj': '1234567891234',
                        'nome': 'teste',
                        'layout': 'teste',
                        'width': 'teste',
                        'sidebar': 'teste',
                        'logow': 'teste',
                        'logob': 'teste',
                        'regtrib': 'teste',
                      }))

                      this.$router.push('/testes')

                    })
                    .catch((error) => {
                      this.tryingToLogIn = false;
                      this.authError = error ? error : "";
                      this.isAuthError = true;
                    })
            );
          } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {


            const { email, password } = this;
            if (email && password) {
              this.login({
                email,
                password,
              });
            }


          } else if (process.env.VUE_APP_DEFAULT_AUTH === "authapi") {

            const { email, password } = this;
            if (email && password) {
              axios
                  .post(`${getBaseUrl()}api/login`, {
                    email: this.email,
                    password: this.password,
                  })
                  .then((res) => {
                    //console.log('res_login_2')
                    //console.log(res.data)
                    //this.$router.push('/');
                    let token = res.data['accessToken']
                    let nome = res.data['userData']['name']
                    let tipo = res.data['userData']['tipo']
                    let menus = res.data['menus']

                    // this.login({
                    //   email,
                    //   password,
                    // });

                    localStorage.setItem('user', JSON.stringify({
                      "id": res.data['userData']['id'],
                      "email": email,
                      "nome": nome,
                      "tipo": tipo,
                      "menus": menus,
                      "token": token
                    }));

                    localStorage.setItem('emprconf', JSON.stringify({
                      'cnpj': res.data['empreatu']['cnpj'],
                      'nome': res.data['empreatu']['fantasia'],
                      'layout': res.data['empreatu']['layout'],
                      'width': res.data['empreatu']['width'],
                      'sidebar': res.data['empreatu']['sidebar'],
                      'logow': res.data['empreatu']['logow'],
                      'logob': res.data['empreatu']['logob'],
                      'regtrib': res.data['empreatu']['regtrib'],
                    }))


                    if (tipo === 'coletor') {
                      this.$router.push('/dashboard/coletor')
                    } else if (tipo.includes('tms_')) {
                      this.$router.push('/dashboard/fretes')
                    } else {
                      this.$router.push('/')
                    }


                  }).catch((error) => {

                console.log('erro login')
                console.log(error)
                this.authError = "E-mail e/ou senha inválido(s), favor corrigir e tentar novamente"
                this.isAuthError = true
                this.updating = false


              })
            }
          }
        }


      }
    },
  },
  mounted() {
    document.body.classList.add("auth-body-bg");


  },
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-xl-9">
<!--          <div class="auth-full-bg pt-lg-5 p-4"  style="background-color: #ffefcc">-->
          <div class="auth-full-bg pt-lg-5 p-4"  style="background-color: white; ">
            <div class="w-100">
              <div class="bg-overlay"></div>

              <div class="d-flex h-25 flex-column">
                <div class="p-4 mt-auto">
                  <div class="row justify-content-center">
                    <div class="col-lg-7">
                      <div class="text-center">
                        <h4 class="mb-3">
                          <i class="bx bxs-quote-alt-left text-primary h1 align-middle me-3" >
                          </i>
                          <span class="text-primary">A Sua</span> Plataforma de Gestão Completa
                        </h4>

                        <div dir="ltr" class="owl-theme">
                          <b-carousel
                            id="carousel-1"
                            :interval="4000"
                            indicators>
                            <b-carousel-slide>
                              <p class="font-size-16 mb-4">
                                "Passivo de customizações "
                              </p>
                              <div>
                                <h4 class="font-size-16 text-primary">
                                  Abs1981
                                </h4>
                                <p class="font-size-14 mb-0">- Compartilhamento de código</p>
                              </div>
                            </b-carousel-slide>

                            <b-carousel-slide>
                              <p class="font-size-16 mb-4">
                                " Escalável "
                              </p>
<!--                              <div>-->
<!--                                <h4 class="font-size-16 text-primary">-->
<!--                                  nezerious-->
<!--                                </h4>-->
<!--                                <p class="font-size-14 mb-0">- Skote User</p>-->
<!--                              </div>-->
                            </b-carousel-slide>
                          </b-carousel>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-3">
          <div class="auth-full-page-content p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="mb-4 mb-md-5">
                  <router-link to="/" class="d-block auth-logo">
                    <img
                      src="@/assets/images/logo-dark.png"
                      alt=""
                      height="18"
                      class="auth-logo-dark"/>
                    <img
                      src="@/assets/images/logo-light.png"
                      alt=""
                      height="18"
                      class="auth-logo-light"/>
                  </router-link>
                </div>
                <div class="my-auto">
                  <div>
                    <h5 class="text-primary">Bem vindo!</h5>
                    <p v-if="!exibeSegLogin" class="text-muted">
                      Favor preencher seu e-mail e senha e clicar em login.
                    </p>

                    <p v-if="exibeSegLogin" class="text-muted">
                      Favor preencher o código que acabamos de enviar para seu WhatsApp.
                    </p>
                  </div>

                  <b-alert
                    v-model="isAuthError"
                    variant="danger"
                    class="mt-3"
                    dismissible>
                    {{ authError }}
                  </b-alert>

                  <div
                    v-if="notification.message"
                    :class="'alert ' + notification.type">
                    {{ notification.message }}
                  </div>
                  <div class="mt-4">

                    <b-form class="p-2" @submit.prevent="segundoLogin">

                      <Loader v-if="updating" style="min-height: 135px;">
                      </Loader>


                      <div v-if="exibeSegLogin && !updating">

                        <b-form-group
                            class="mb-3"
                            id="input-veri-1-label"
                            label="Código de Verificação"
                            label-for="input-veri-1">
                          <b-form-input
                              id="input-veri-1"
                              v-model="codverify"
                              type="number"
                              placeholder="Código de verificação"
                              :class="{'is-invalid': submitted_2 && v$.codverify.$error,}">
                          </b-form-input>
                          <div
                              v-if="submitted_2 && !codverify"
                              class="invalid-feedback">
                          <span v-if="submitted_2 && !codverify">
                            Campo código de verificação obrigatório, favor preencher.
                          </span>

                          </div>
                        </b-form-group>

                        <div class="mt-3 d-grid" >
                          <b-button type="submit" variant="primary">
                            Log In
                          </b-button>
                        </div>

                      </div>


                      <div v-if="!exibeSegLogin && !updating">


                        <b-form-group
                          class="mb-3"
                          id="input-group-1"
                          label="Email"
                          label-for="input-1">
                          <b-form-input
                            id="input-1"
                            v-model="email"
                            type="text"
                            placeholder="Enter email"
                            :class="{'is-invalid': submitted_1 && v$.email.$error,}"
                            :disabled="updating">
                          </b-form-input>
                          <div
                            v-if="submitted_1 && v$.email.$error"
                            class="invalid-feedback">
                            <span v-if="!v$.email.required">
                              Email is required.
                            </span>
                            <span v-if="!v$.email.email">
                              Please enter valid email.
                            </span>
                          </div>
                        </b-form-group>

                        <b-form-group
                          class="mb-3"
                          id="input-group-2"
                          label="Senha"
                          label-for="input-2">
                          <b-form-input
                            id="input-2"
                            v-model="password"
                            type="password"
                            placeholder="Enter password"
                            :class="{'is-invalid': submitted_1 && v$.password.$error,}"
                            :disabled="updating">
                          </b-form-input>
                          <div
                            v-if="submitted_1 && v$.password.$error"
                            class="invalid-feedback">
                            <span v-if="v$.password.required.$message">
                              {{ v$.password.required.$message }}
                            </span>
                          </div>
                        </b-form-group>

                        <div class="form-check" v-if="!updating" >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="remember-check"/>
                          <label class="form-check-label" for="remember-check">
                            Mantenha-me logado
                          </label>
                        </div>

                        <div class="mt-3 d-grid" v-if="!updating" >
                          <b-button variant="primary" @click="segundoLogin">
                            Log In
                          </b-button>
                        </div>

<!--                        <div class="mt-4 text-center" v-if="!updating" >-->
<!--                          <h5 class="font-size-14 mb-3">Login com</h5>-->

<!--                          <ul class="list-inline">-->
<!--                            <li class="list-inline-item">-->
<!--                              <a class="social-list-item bg-primary text-white border-primary">-->
<!--                                <i class="mdi mdi-facebook"></i>-->
<!--                              </a>-->
<!--                            </li>-->
<!--                            <li class="list-inline-item">-->
<!--                              <a class="social-list-item bg-info text-white border-info">-->
<!--                                <i class="mdi mdi-twitter"></i>-->
<!--                              </a>-->
<!--                            </li>-->
<!--                            <li class="list-inline-item">-->
<!--                              <a class="social-list-item bg-danger text-white border-danger">-->
<!--                                <i class="mdi mdi-google"></i>-->
<!--                              </a>-->
<!--                            </li>-->
<!--                          </ul>-->
<!--                        </div>-->

                      </div>

                    </b-form>

                    <div class="mt-5 text-center" v-if="!updating">
                      <p>
                        Ainda não possui conta?
                        <a href="javascript: void(0);"
                          @click="criarConta"
                          class="fw-medium text-primary">
                          Criar nova conta
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="mt-4 mt-md-5 text-center">
                  <p class="mb-0">
                    ©
                    {{ new Date().getFullYear() }}
                    <i class="mdi mdi-rocket-launch text-primary"></i> Econocargo
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<style lang="scss" scoped>
.carousel-caption {
  position: relative !important;
  right: 0;
  bottom: 1.25rem;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
  text-align: center;
}

.carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}
</style>
